import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'

import PropTypes from 'prop-types'
import moment from 'moment'
import get from 'lodash/get'
import clone from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import { deepOmit } from './../../libs/utils'
import { GET_TRIPS, GET_CUSTOMIZED_PLANS_LIST, UPDATE_CUSTOMIZED_PLAN, UPDATE_ITINERARY_DAY, UPDATE_TRIP_DETAILS } from './../../graphql/MyTrips'
import UPDATE_CUSTOMIZED_PLAN_ORDER_STATUS from './../../graphql/UpdatePlan.graphql'
import { NotificationManager } from 'react-notifications'
import CopyModal from './CopyModal'
import TripCard from './TripCard'
import Loader from '../UI/Loader'



class MyTrips extends Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func
    }),
    userQuery: PropTypes.object,
    allCustomizedPlansQuery: PropTypes.shape({
      loading: PropTypes.bool,
      allCustomizedPlans: PropTypes.array,
      refetch: PropTypes.func
    }),
    updateCustomizedPlan: PropTypes.func,
    updateItineraryDay: PropTypes.func,
    updateTripDetails: PropTypes.func,
    updateCustomizedPlanOrderStatus: PropTypes.func,
    showTrips: PropTypes.bool,
    t: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      isCopyModalOpen: false,
      selectedTripIndex: null
    }
  }

  goToTripForm() {
    this.props.history.push('/create-trip')
  }

  goToPrepaidTripForm() {
    this.props.history.push('/prepaid-trip')
  }


  goToPlanner(id) {
    this.props.history.push(`/trip-planner/${id}`)
  }

  closeModal() {
    this.setState(() => ({
      isCopyModalOpen: false,
      selectedTripIndex: null
    }))
  }

  editOrderUserDetails(id) {
    this.props.history.push(`/edit-order-user-details/${id}`)    
  }

  async deleteTrip(id) {
    try {
      await this.props.updateCustomizedPlanOrderStatus({
        variables: {
          id,
          orderStatus: 'Archived'
        }
      })
      await this.props.allCustomizedPlansQuery.refetch()
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }

  async onCopySave(data) {
    const plans = get(this.props, 'allCustomizedPlansQuery.allCustomizedPlans', [])

    const source = plans[this.state.selectedTripIndex]
    const destination = plans.find(plan => {
      if (plan) {
        return plan.id === data.selectedDestinationId
      }
    })

    const sourceCopy = clone(source)

    sourceCopy.id = destination.id
    sourceCopy.startDate = destination.startDate
    sourceCopy.endDate = destination.endDate
    sourceCopy.numDays = destination.numDays

    sourceCopy.tripDetails = clone(destination.tripDetails)
    sourceCopy.tripDetails.title = data.title
    sourceCopy.tripDetails.description = source.tripDetails.description

    delete sourceCopy.travelers
    delete sourceCopy.tripGuru

    sourceCopy.tripDetails.itineraryDays.forEach(day => {
      const sourceDay = source.tripDetails.itineraryDays.find(({ index }) => index === day.index)

      const diff = moment(day.dayOfTrip).diff(moment(sourceDay.dayOfTrip), 'days')

      const events = clone(sourceDay.contentEvents)

      events.forEach(event => {
        if (!isEmpty(event.defaultPhoto)) {
          event.defaultPhoto = event.defaultPhoto.id
        }

        if (Array.isArray(event.docs) && event.docs.length) {
          event.docs = event.docs.map(doc => doc.id)
        }

        if (Array.isArray(event.photos) && event.photos.length) {
          event.photos = event.photos.map(photo => photo.id)
        }

        delete event.defaultPhoto

        event.startDate = moment(event.startDate)
          .add(diff, 'days')
          .toISOString()
        event.endDate = moment(event.endDate)
          .add(diff, 'days')
          .toISOString()

        event.docs = []
        event.photos = []
      })

      day.contentEvents = deepOmit(events, ['id', '__typename'])
    })

    try {
      await this.props.updateCustomizedPlan({
        variables: { ...sourceCopy, orderStatus: 'NewOrder' }
      })

      await this.props.updateTripDetails({
        variables: sourceCopy.tripDetails
      })

      await Promise.all(
        sourceCopy.tripDetails.itineraryDays.map(day => {
          return this.props.updateItineraryDay({
            variables: day
          })
        })
      )

      this.closeModal()
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }

  render() {
    if ((this.props.showTrips && this.props.allTripsQuery.loading) ||
          (!this.props.showTrips && this.props.allCustomizedPlansQuery.loading)) {
      return <Loader showLoader={true} />
    }
    const { customizedplan } = this.props.showTrips ? this.props.allTripsQuery : this.props.allCustomizedPlansQuery
     //alert(allCustomizedPlans.length)
    return (
      <div className="trips">
        <div className="trips__header">
          <h1>{this.props.t('page_title')}</h1>
          <div>
            {this.props.user && this.props.user.plannerProfile && this.props.user.plannerProfile.allowPrepaidTrips &&
            <button
              className="trips__add-button"
              onClick={() => {
                this.goToPrepaidTripForm()
              }}
            >
              {this.props.t('add_prepaid_trip')}
            </button>
            }
            { !this.props.showTrips &&
            <button
              className="trips__add-button"
              onClick={() => {
                this.goToTripForm()
              }}
            >
              {this.props.t('add_trip')}
            </button>
            }
          </div>
        </div>
        {
          Array.isArray(customizedplan) &&
          customizedplan.map((trip, i) => (
           
            <TripCard
              key={i}
              index={i}
              data={trip}
              showAsTrip={this.props.showTrips}
              onPreviewClick={id => {
                this.props.history.push(`/my-trips/${id}`)
              }}
              onEditClick={id => {
                this.goToPlanner(id)
              }}
              onCopyClick={selectedTripIndex => {
                this.setState(() => ({
                  isCopyModalOpen: true,
                  selectedTripIndex
                }))
              }}
              onDeleteClick={id => this.deleteTrip(id)}
              onEditUserDetails={id => this.editOrderUserDetails(id)}
            />
          ))}
          { !this.props.showTrips &&
          <button
            className="trips__add-button trips__add-button__bottom"
            onClick={() => {
              this.goToTripForm()
            }}
          >
            {this.props.t('add_trip')}
          </button>
          }
        {this.props.user && this.props.user.plannerProfile && this.props.user.plannerProfile.allowPrepaidTrips &&
        <button
          className="trips__add-button trips__add-button__bottom"
          onClick={() => {
            this.goToPrepaidTripForm()
          }}
        >
          {this.props.t('add_prepaid_trip')}
        </button>
        }
        {this.state.selectedTripIndex && (
          <CopyModal
            isCopyModalOpen={this.state.isCopyModalOpen}
            user={this.props.user}
            sourceTrip={customizedplan[this.state.selectedTripIndex]}
            allCustomizedPlans={customizedplan}
            onSave={data => this.onCopySave(data)}
            onClose={() => {
              this.closeModal()
            }}
          />
        )}
      </div>
    )
  }
}

export default compose(
  translate('my_trips'),
  graphql(GET_CUSTOMIZED_PLANS_LIST, {
    name: 'allCustomizedPlansQuery',
    options: props => ({
      variables: {
        tripGuruId: get(props, 'user.id', '')
      }
    })
  }),
  graphql(GET_TRIPS, {
    name: 'allTripsQuery',
    options: props => ({
      variables: {
        orderingUserId: get(props, 'user.id', '')
      }
    })
  }),
  graphql(UPDATE_CUSTOMIZED_PLAN, {
    name: 'updateCustomizedPlan'
  }),
  graphql(UPDATE_TRIP_DETAILS, {
    name: 'updateTripDetails'
  }),
  graphql(UPDATE_ITINERARY_DAY, {
    name: 'updateItineraryDay'
  }),
  graphql(UPDATE_CUSTOMIZED_PLAN_ORDER_STATUS, {
    name: 'updateCustomizedPlanOrderStatus'
  })
)(MyTrips)



// WEBPACK FOOTER //
// src/components/MyTrips/index.js